module.exports = __webpack_public_path__ + "img/categories.e3bfcec8.svg";